module.exports = __webpack_public_path__ + "fonts/f1307da895e9812b2cd9e3c2551893d2.svg";